<template>
  <WBDAutoCompleteSelectorFilter
    :remote-list="remoteList"
    :label="label"
    :on-change-event="onChangeEvent"
    :remote-option-value="selectedOptionValue"
    :model-list="modelList"
    :on-search-request-callback="onCitySelectorFilterChange"
    :clear-event="clearEvent"
    :loading="loading"
    :onSearchRequestCallback="requestData"
    @click:append="requestData"
    @onCitySelectorFilterChange="onCitySelectorFilterChange"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import DictionaryMixin from '@/mixins/dictionaryMixin'
import WBDAutoCompleteSelectorFilter from '@/components/common/filter/auto-complete-filter'

export default {
  name: 'WBDCitySelectorFilter',
  components: {
    WBDAutoCompleteSelectorFilter,
  },
  mixins: [DictionaryMixin],
  props: {
    remoteOptionValue: {
      type: [String, Object],
    },
    remoteList: {
      type: Array,
    },
    label: {
      type: String,
      default: 'Поиск городов (от 2-х букв)',
    },
  },
  data () {
    return {
      modelList: [],
      clearEvent: null,
      onChangeEvent: 'onCitySelectorFilterChange',
      loading: false,
      selectedOptionValue: null,
    }
  },
  computed: {
    ...mapGetters({
    }),
  },
  created () {
    if (this.remoteOptionValue) {
      this.selectedOptionValue = this.remoteOptionValue
    }
    if (this.remoteList && this.remoteList.length) {
      this.modelList = this.remoteList
      this.selectedOptionValue = this.remoteList[0]
    }
    this.clearEvent = this.eventNames.CITY_SEARCH_FILTER_RESET

    this.eventsBus.$on(this.clearEvent, () => {
      this.selectedModelList = null
      this.$emit(
        this.onChangeEvent,
        null
      )
    })
  },
  methods: {
    async requestData (searchQuery) {
      try {
        this.loading = true
        const params = { 'addRegion': '0', 'page[number]': 1, 'page[size]': 50 }
        if (searchQuery && (searchQuery.trim() === '' || searchQuery.trim().length < 2)) {
          return
        }
        params.searchQuery = searchQuery
        const list = await this.$store.dispatch(
          'organization/getLocalityList',
          { params }
        )

        this.modelList = list.data

        setTimeout(() => {
          this.loading = false
        }, 1500)
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    onCitySelectorFilterChange (id, city) {
      this.$emit(
        this.onChangeEvent,
        id,
        city
      )
    },
  }
}
</script>
